import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../hook/userAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_API } from "../../ruta-server/BaseApi";
import { Loader, Dropdown } from "semantic-ui-react";
import { MisGrupos } from "../../components/Users/TableTeachers/Cursos/MisGrupos";

function ConsultaGrupos() {
  const { auth } = useAuth();
  if (!auth?.me?.es_docente) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaConsultarGrupos />;
}

function LogicaConsultarGrupos() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch] = useState(false);
  const [cursosDocente, setCursosDocente] = useState(null);
  const [periodos, setPeriodos] = useState(null);
  const [loadingCursosDocente, setLoadingCursosDocente] = useState(true);
  const [loadingPeriodos, setLoadingPeriodos] = useState(true);
  const [loadingAsesoradosDocente, setLoadingAsesoradosDocente] =
    useState(true);
  const [cursosAsignadosTitulacion, setCursosAsignadosTitulacion] = useState(
    []
  );
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [selectedPeriodoId, setSelectedPeriodoId] = useState(null);

  // Obtención de los periodos
  async function getPeriodos() {
    try {
      setLoadingPeriodos(true);
      const response = await axios.get(`${BASE_API}/api/periodo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const periodos = response.data;
      setLoadingPeriodos(false);
      setPeriodos(periodos);
      return periodos;
    } catch (error) {
      setLoadingPeriodos(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getPeriodos();
    // eslint-disable-next-line
  }, [refetch]);

  const getPeriodoMasReciente = (periodos) => {
    if (!periodos || periodos.length === 0) return null;
    const periodoMasReciente = periodos.reduce((prev, current) => {
      const prevInicio = new Date(prev.fecha_inicio);
      const prevFin = new Date(prev.fecha_fin);
      const currentInicio = new Date(current.fecha_inicio);
      const currentFin = new Date(current.fecha_fin);
      return currentInicio > prevInicio ||
        (currentInicio.getTime() === prevInicio.getTime() &&
          currentFin > prevFin)
        ? current
        : prev;
    });
    return periodoMasReciente;
  };

  useEffect(() => {
    if (periodos) {
      const periodoInicial = getPeriodoMasReciente(periodos);
      setSelectedPeriodo(periodoInicial);
      setSelectedPeriodoId(periodoInicial?.id_periodo);
      if (periodoInicial) {
        getCursosDocente(periodoInicial.id_periodo);
      }
    }
    // eslint-disable-next-line
  }, [periodos]);

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };

  function formatoDropdownPeriodo(informacionCicloEscolar) {
    if (!informacionCicloEscolar || informacionCicloEscolar.length === 0) {
      return [];
    }
    return informacionCicloEscolar.map((item) => ({
      key: item.id_periodo,
      text: `${formatPeriodo(item.fecha_inicio)} - ${formatPeriodo(
        item.fecha_fin
      )}`,
      value: item.id_periodo,
    }));
  }

  const handlePeriodoChange = (event, data) => {
    const periodoSeleccionado = periodos.find(
      (periodo) => periodo.id_periodo === data.value
    );
    setSelectedPeriodo(periodoSeleccionado);
    setSelectedPeriodoId(data.value);
    getCursosDocente(data.value); // Llamada a la API con el ID del periodo seleccionado
  };

  async function getCursosDocente(periodoId) {
    try {
      setLoadingCursosDocente(true);
      const response = await axios.get(
        `${BASE_API}/api/curso/?periodo=${periodoId}&docente=${auth.me.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const cursosDelDocente = response.data;
      setLoadingCursosDocente(false);
      setCursosDocente(cursosDelDocente);
      return cursosDelDocente;
    } catch (error) {
      setLoadingCursosDocente(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosDocente(selectedPeriodoId);
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  async function getCursosTitulacionAsignados(docenteId, periodoId) {
    try {
      setLoadingAsesoradosDocente(true);
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?docente_asesor=${docenteId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const cursosData = response.data;
      const cursosFiltrados = cursosData.filter(
        (curso) => curso.curso_data.periodo === periodoId
      );

      const cursosAgrupados = cursosFiltrados.reduce((acc, curso) => {
        if (!acc[curso.curso]) {
          acc[curso.curso] = {
            ...curso.curso_data,
            alumnos: [],
          };
        }
        acc[curso.curso].alumnos.push(curso.alumno_data);
        return acc;
      }, {});

      const cursosAgrupadosList = Object.values(cursosAgrupados);
      setLoadingAsesoradosDocente(false);
      return cursosAgrupadosList;
    } catch (error) {
      setLoadingAsesoradosDocente(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosTitulacionAsignados(auth.me.id, selectedPeriodoId).then(
        (cursos) => {
          setCursosAsignadosTitulacion(cursos);
        }
      );
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  const calificarCurso = async (data) => {
    navigate("/mis-grupos/CalificarAlumnosCurso", {
      state: { datosCurso: data },
    });
  };

  return (
    <div>
      <h1 className="tituloin">Mis grupos</h1>
      {loadingPeriodos ? (
        <Loader active inline="centered">
          Cargando periodos....
        </Loader>
      ) : (
        <div
          style={{
            maxWidth: "70%",
            paddingTop: "12px",
            paddingBottom: "24px",
          }}
        >
          <div>
            <label>Filtrar por periodo</label>
          </div>
          <Dropdown
            placeholder="Seleccionar Periodo"
            fluid
            selection
            options={formatoDropdownPeriodo(periodos)}
            onChange={handlePeriodoChange}
            value={selectedPeriodoId}
          />
        </div>
      )}
      {loadingCursosDocente && loadingAsesoradosDocente ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <MisGrupos
          cursosDocente={cursosDocente}
          cursosAsignadosTitulacion={cursosAsignadosTitulacion}
          calificarCurso={calificarCurso}
          periodoSeleccionado={selectedPeriodo} // Pasa el periodo seleccionado
        />
      )}
    </div>
  );
}

export default ConsultaGrupos;
